import { useEffect, useState } from 'react';

const TIMEOUT_SECONDS = 60;

export default function Matchmaking({ onCancel }) {
  const [dots, setDots] = useState('');
  const [elapsed, setElapsed] = useState(0);
  const remaining = TIMEOUT_SECONDS - elapsed;
  const progress = (elapsed / TIMEOUT_SECONDS) * 100;

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((d) => (d.length >= 3 ? '' : d + '.'));
    }, 500);
    const timeInterval = setInterval(() => setElapsed((e) => e + 1), 1000);
    return () => {
      clearInterval(dotsInterval);
      clearInterval(timeInterval);
    };
  }, []);

  const timerColor = remaining <= 10 ? '#ef4444' : remaining <= 20 ? '#f59e0b' : '#6366f1';

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Radar animation */}
        <div style={styles.radarWrapper}>
          <div style={styles.radarRing1} />
          <div style={styles.radarRing2} />
          <div style={styles.radarRing3} />
          <div style={styles.radarCenter}>
            <span style={styles.radarIcon}>👤</span>
          </div>
        </div>

        <h2 style={styles.title}>Finding Opponent{dots}</h2>
        <p style={styles.subtitle}>Searching the arena</p>

        {/* Countdown timer */}
        <div style={{ textAlign: 'center' }}>
          <p style={{ ...styles.timer, color: timerColor }}>
            {remaining > 0 ? remaining : 0}s
          </p>
          <p style={styles.timerLabel}>
            {remaining > 10
              ? 'Looking for a match...'
              : remaining > 0
              ? 'Almost out of time...'
              : 'Timing out...'}
          </p>
        </div>

        {/* Progress bar */}
        <div style={styles.progressTrack}>
          <div
            style={{
              ...styles.progressBar,
              width: `${100 - progress}%`,
              background: timerColor,
            }}
          />
        </div>

        <button style={styles.cancelBtn} onClick={onCancel}>
          Leave Queue
        </button>
      </div>

      <style>{`
        @keyframes ping1 { 0%,100%{transform:scale(1);opacity:.6} 50%{transform:scale(1.15);opacity:.2} }
        @keyframes ping2 { 0%,100%{transform:scale(1);opacity:.4} 50%{transform:scale(1.2);opacity:.1} }
        @keyframes ping3 { 0%,100%{transform:scale(1);opacity:.25} 50%{transform:scale(1.3);opacity:.05} }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '100vh', background: '#0d0d1a',
  },
  card: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    gap: '16px', padding: '48px 40px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '24px', backdropFilter: 'blur(20px)',
    minWidth: '320px',
  },
  radarWrapper: { position: 'relative', width: '120px', height: '120px', marginBottom: '8px' },
  radarRing1: {
    position: 'absolute', inset: 0, borderRadius: '50%',
    border: '2px solid rgba(99,102,241,0.6)',
    animation: 'ping1 2s ease-in-out infinite',
  },
  radarRing2: {
    position: 'absolute', inset: '10px', borderRadius: '50%',
    border: '2px solid rgba(99,102,241,0.4)',
    animation: 'ping2 2s ease-in-out infinite 0.3s',
  },
  radarRing3: {
    position: 'absolute', inset: '20px', borderRadius: '50%',
    border: '2px solid rgba(99,102,241,0.25)',
    animation: 'ping3 2s ease-in-out infinite 0.6s',
  },
  radarCenter: {
    position: 'absolute', inset: '30px', borderRadius: '50%',
    background: 'rgba(99,102,241,0.2)', display: 'flex',
    alignItems: 'center', justifyContent: 'center',
    border: '2px solid rgba(99,102,241,0.5)',
  },
  radarIcon: { fontSize: '28px' },
  title: {
    margin: 0, fontSize: '22px', fontWeight: '700',
    color: '#fff', fontFamily: "'Syne', sans-serif", letterSpacing: '-0.5px',
  },
  subtitle: { margin: 0, fontSize: '14px', color: 'rgba(255,255,255,0.4)' },
  timer: {
    margin: 0, fontSize: '42px', fontWeight: '800',
    fontFamily: 'monospace', letterSpacing: '2px',
    transition: 'color 0.5s ease',
  },
  timerLabel: {
    margin: '4px 0 0', fontSize: '12px',
    color: 'rgba(255,255,255,0.3)',
  },
  progressTrack: {
    width: '100%', height: '4px', borderRadius: '2px',
    background: 'rgba(255,255,255,0.08)', overflow: 'hidden',
  },
  progressBar: {
    height: '100%', borderRadius: '2px',
    transition: 'width 1s linear, background 0.5s ease',
  },
  cancelBtn: {
    marginTop: '8px', padding: '10px 28px',
    background: 'transparent', border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '12px', color: 'rgba(255,255,255,0.5)',
    fontSize: '14px', cursor: 'pointer',
  },
};